import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import './ExpiredTimeConfirmationModal.scss';

/**
 * UI to show the user about their
 * expired time for the Quiz
 * */
class ExpiredTimeConfirmationModal extends PureComponent {
  static displayName = 'ExpiredTimeConfirmationModal';

  static propTypes = {
    isSoftTime: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onShowModal: PropTypes.func.isRequired,
    learnositySubmit: PropTypes.func.isRequired,
    onExitPlayer: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isSoftTime: true,
  };

  state = {
    hasConfirm: false,
  };

  componentDidMount() {
    const { isSoftTime, learnositySubmit } = this.props;
    // for hardtime assesment auto submit the student quiz
    if (!isSoftTime) {
      learnositySubmit();
    }
  }

  handleSubmitNow = () => {
    this.props.onShowModal('SubmitConfirmation');
  };

  backToPlayer = () => {
    // for soft time if the student clicks the Continue button close the modal
    this.props.onClose();
  };

  render() {
    const { hasConfirm } = this.state;
    const { isSoftTime, onExitPlayer } = this.props;

    let content;
    if (hasConfirm) {
      if (isSoftTime) {
        content = <div>You have successfully submitted your assessment.</div>;
      } else {
        content = (
          <div className="flex flex-col gap-8">
            <div>You have successfully submitted your exam.</div>
            <div>It is now safe to exit the browser.</div>
          </div>
        );
      }
    } else if (isSoftTime) {
      content = (
        <div>
          You can submit your assessment now or continue working for as long as
          your teacher leaves the assessment unlocked.
        </div>
      );
    } else {
      content = (
        <div>Your test time has expired and your exam has been submitted.</div>
      );
    }

    const isInformationalModal = hasConfirm || !isSoftTime;
    const onSoftTimeModalClose = isSoftTime
      ? this.handleSubmitNow
      : () => this.setState({ hasConfirm: true });
    const onModalClose = hasConfirm ? onExitPlayer : onSoftTimeModalClose;

    let modalContent;
    if (isInformationalModal) {
      modalContent = {
        btnPrimary: hasConfirm ? 'Exit' : 'Ok',
      };
    } else {
      modalContent = {
        btnPrimary: 'Continue',
        btnSecondary: 'Submit Now',
      };
    }

    return (
      <ConfirmDialog
        size="tiny"
        title={isSoftTime ? 'Time is up!' : 'Submit'}
        showCloseButton={isSoftTime}
        onClose={this.backToPlayer}
        onSuccess={this.backToPlayer}
        onSecondaryBtnClick={onModalClose}
        aria={{
          'aria-live': 'polite',
        }}
        content={modalContent}
      >
        {content}
      </ConfirmDialog>
    );
  }
}

export default ExpiredTimeConfirmationModal;
